module.exports = __webpack_public_path__ + "static/media/My One Safe Haven.7fd0d1a7.jpg";